if (process.env.NODE_ENV === 'production') {
    module.exports = require('./dev-tools.prod')
} else {
    module.exports = require('./dev-tools.dev')
}
